module.exports = __webpack_public_path__ + "media/luxury-2026/nash-architectural-exterior-4e90258f.jpg";